export default "/_next/static/images/efda60f543630a35eb6261cad5d0775d.png";